module.exports = __webpack_public_path__ + "img/logo.c6a2d1a3.png";